import aws4 from 'aws4';

import { credentials } from './credentials';
let history, path;

const request = async ({ method, path, body }) => {
    path = `/api${path}`;
    let retry = 2;
    while (true) {
        const options = {
            host: 'sofc.api.dev.doosanfuelcell.cloud',
            service: 'execute-api',
            path,
            method,
            body: JSON.stringify(body),
            credentials: 'omit'
        };
        aws4.sign(options, {
            secretAccessKey: credentials.SecretKey,
            accessKeyId: credentials.AccessKeyId,
            sessionToken: credentials.SessionToken
        });
        const response = await fetch(path, options);
        if (!response.ok) {
            if ([502, 504].includes(response.status) && retry > 0) {
                retry--;
                continue;
            }
            throw response;
        }
        return response.json();
    }
};


export const setHistory = (newHistory) => {
    history = newHistory;
};

export const setPath = (newPath) => {
    path = newPath;
};

export const handleError = ({ status, message }) => {
    // history.push('/error', { message: message || status });
    if (status === 401 || status === 403 || message === 'offline') {
        return;
    }
};


export const getCredentials = async (token) => {
    const response = await fetch('/api/credentials', { headers: { Authorization: token } });
    if (!response.ok) {
        throw response;
    }
    return response.json();
};

export const getToken = async (token) => {
    const options = {
        method: 'POST',
        body: new URLSearchParams({
            refresh_token: token,
            grant_type: 'refresh_token',
            client_id: '7vemdckc8mjjrepkqu7qncpkt9'
        })
    };
    const response = await fetch('https://rms.auth.us-east-1.amazoncognito.com/oauth2/token', options);
    if (!response.ok) {
        throw response;
    }
    return response.json();
};

export const createUserLog = (body) => {
    return request({ method: 'POST', path: '/hmi/log', body });
};

export const getFleet = () => {
    return request({ method: 'GET', path: '/fleet' });
};

/**** S3 Retune *****/

export const uploadRetune = (body) => {
    return request({ method: 'POST', path: '/hmi/retune', body});
};

export const getRetune = (ppid) => {
    const qs = new URLSearchParams(ppid);
    return request({ method: 'GET', path: `/hmi/retune?${qs}`});
};
